// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qVsaq","location":"Header_location__29AFH"};